import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BASE_URL = "https://api.jeyshawnng.com";
const POLL_INTERVAL = 30000;

export function useContactMessagesBadge() {
  const [unreadCount, setUnreadCount] = useState(0);
  const [recent, setRecent] = useState([]);

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}/api/contact/messages`, authHeaders());
      const messages = data?.data || [];
      setUnreadCount(messages.filter(m => !m.isRead).length);
      setRecent(messages.slice(0, 5));
    } catch (err) {
      console.warn('Failed to refresh contact message badge:', err.message);
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [refresh]);

  return { unreadCount, recent, refresh };
}